<template>
  <div>
    <div class="structured-top">
      <h1 v-mark-word="-1">{{ title || page.title }}</h1>
      <slot name="after-title" />
    </div>
    <div class="structured-content positive ">
      <slot>
        <template v-if="page.caption">
          <span class="p-header p-title">{{ page.caption.title }}</span>
          <span class="p-header p-date">{{ page.caption.date }}</span>
          <p>{{page.caption.paragraph}}</p>
        </template>
        <div :class="contentClass" v-html="page.content" ref="content" />
      </slot>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { scrollTo } from '../utils/scroll';

export default {
  props: {
    id: String,
    title: String,
    meta: Object,
    contentClass: { String, default: 'with-content primary' },
  },
  data: () => ({
    page: {},
  }),
  watch: {
    pageId: {
      immediate: true,
      handler: 'loadPage',
    },
    page(page) {
      this.$emit('update:page', page);
    },
  },
  computed: {
    pageId() {
      return this.id ? `${this.id}.${this.$i18n.locale}` : '';
    },
  },
  methods: {
    ...mapActions('page', {
      getPage: 'loadPage',
    }),

    loadPage(id) {
      if (!id) {
        return Promise.resolve();
      }

      return this.getPage(id)
        .then((page) => {
          this.page = page;
          this.scrollTo(this.$route.hash.slice(1));
        });
    },

    scrollTo(id) {
      if (id) {
        this.$nextTick(() => scrollTo(id, { duration: 0 }));
      }
    },
  },
  metaInfo() {
    const page = this.page || {};
    const meta = page.meta || this.meta || {};

    return {
      title: page.title || meta.title,
      meta: [
        { vmid: 'keywords', name: 'keywords', content: meta.keywords },
        { vmid: 'description', name: 'description', content: meta.description },
      ],
    };
  },
};
</script>
